import html from "assets/html.svg";
import css from "assets/css.svg";
import sass from "assets/sass.svg";
import javascript from "assets/javascript.svg";
import react from "assets/react.svg";
import reactNative from "assets/react native.svg";
import redux from "assets/redux.svg";
import node from "assets/node.svg";
import express from "assets/express.svg";
import mongoDB from "assets/mongodb.svg";
import git from "assets/git.svg";
import gitHub from "assets/github.svg";
import terminal from "assets/terminal.svg";
import vsc from "assets/vsc.svg";
import json from "assets/json.svg";
import adobe from "assets/adobexd.svg";
import figma from "assets/figma.svg";
import photoshop from "assets/photoshop.svg";

const data = [
  html,
  css,
  sass,
  javascript,
  react,
  reactNative,
  redux,
  node,
  express,
  mongoDB,
  git,
  gitHub,
  terminal,
  vsc,
  json,
  adobe,
  figma,
  photoshop,
];

export default data;
